export const API_URL = process.env.REACT_APP_API_URL || 'https://app.tghunter.ru/api';

export const URLS = {
    SIGN_IN: '/accounts/token/',
    REGISTER: '/accounts/register/',
    REFRESH: '/accounts/token/refresh/',
    CONFIRM_EMAIL: '/accounts/confirm-email/',
    REFETCH_EMAIL_CODE: '/accounts/confirm-email/refetch-code/',
    PASSWORD_RESET: '/accounts/password-reset/',
    UPDATE_ONBOARDING_STEP: '/accounts/update-onboarding-step/',
    PASSWORD_CONFIRM_RESET: '/accounts/password-reset-confirm/',
    CHANGE_EMAIL: '/accounts/change-email/request/',
    CHANGE_EMAIL_CONFIRM: '/accounts/change-email/confirm/',
    USER: '/accounts/me/',
    SUBSCRIPTIONS: '/subscriptions/plans/',
    SUBSCRIPTIONS_CUSTOM_PLAN_SETTINGS: '/subscriptions/custom-plan-settings/',
    SUBSCRIPTIONS_CREATE_PAYMENT: '/subscriptions/create-payment/',
    SUBSCRIPTIONS_CANCEL: '/subscriptions/cancel/',
    SUBSCRIPTIONS_VALIDATE_PROMO_CODE: '/subscriptions/validate-promo-code/',
    SUBSCRIPTIONS_MY_PROMOCODE: '/subscriptions/my-promocode/',
    SUBSCRIPTIONS_MY_REFERRALS: '/subscriptions/my-referrals/',
    PROJECTS: '/projects/',
    PROJECTS_CREATE: '/projects/create/',
    CHATS: '/chats/',
    KEYWORDS: '/keywords/',
    BUNDLES: '/chats/bundles/',
    BUNDLES_CREATE: '/chats/bundles/create/',
    MESSAGES: '/messages/',
    DESCRIPTION: '/accounts/update-description',
    NICHE_ANALYSIS: '/projects/niche-analysis/',
    LEAD_EXAMPLES: '/lead-streams/examples/',
    SAVE_NICHE_ANALYSIS: '/projects/save-niche-analysis/',
    SAVE_SELECTED_LEADS: '/projects/save-selected-leads/',
    SAVE_SELECTED_CHATS: '/projects/save-selected-chats/',
    SAVE_SELECTED_COLLECTIONS: '/projects/save-selected-collections/',
    GET_PROJECT_RECOMMENDED_COLLECTIONS: '/projects',
};
